import { FormControlLabel, Switch } from "@material-ui/core";
import { FieldConfig, useField } from "formik";

interface Props extends FieldConfig {
  label?: string | null;
  name: string;
  labelPlacement?: "start" | "end" | "top" | "bottom";
  disabled?: boolean;
  checked?: boolean;
  onClick?: () => void;
}

const SwitchField = ({
  label,
  name,
  labelPlacement,
  disabled,
  onClick,
  checked,
  ...props
}: Props) => {
  const [field] = useField(name);
  return (
    <div>
      <FormControlLabel
        control={
          <Switch
            checked={checked !== undefined ? checked : field.value}
            {...field}
            {...props}
            disabled={disabled}
            onClick={onClick}
          />
        }
        label={label}
        labelPlacement={labelPlacement || "start"}
      />
    </div>
  );
};

export default SwitchField;
